import React from 'react';
import { WindowHeightProvider } from './WindowHeightProvider';
import { HeightProvider } from './HeightProvider';

/**
 * @component
 * There has to be a better name for this.
 *
 * @see WindowHeightProvider
 * @see HeightProvider
 */
export const HeightProviderWithWindowHeight = ({
  children,
  passedRef
}) => /*#__PURE__*/React.createElement(WindowHeightProvider, null, windowHeight => /*#__PURE__*/React.createElement(HeightProvider, {
  passedRef: passedRef
}, height => children({
  windowHeight,
  height
})));